/**
 * The supported CAPTCHA implementations.
 */
export var CaptchaType;
(function (CaptchaType) {
    /**
     * Renders a Google reCAPTCHA V2 component.
     */
    CaptchaType["GoogleRecaptchaV2"] = "GoogleRecaptchaV2";
})(CaptchaType || (CaptchaType = {}));
//# sourceMappingURL=type.js.map